import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ProtocolSectionAnswersBatchHttpRequestModel } from '../httpQueue/protocolSectionAnswersBatch/types';
import { ProtocolSectionAnswersBatchOutDto } from 'shared/dtos/out/protocolAnswer';

export class ProtocolSectionAnswersBatchEditor {
  constructor(
    private addRequest: (
      request: ProtocolSectionAnswersBatchHttpRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    inspectionId: string,
    sectionId: string,
    protocolSectionAnswersBatchOutDto: ProtocolSectionAnswersBatchOutDto,
    protocolItemIds: string[],
    uniqueId: string,
    projectId: string
  ): Promise<void> {
    debugLog(
      'ProtocolSectionAnswersBatchEditor',
      inspectionId,
      sectionId,
      protocolSectionAnswersBatchOutDto,
      protocolItemIds
    );
    const request: ProtocolSectionAnswersBatchHttpRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        inspectionId,
        sectionId,
        protocolSectionAnswersBatchOutDto,
        protocolItemIds,
        uniqueId,
        projectId,
      },
      entityType: HttpRequestModelType.protocolSectionAnswersBatch,
      status: HttpRequestStatus.NEW,
      url: `/project/${projectId}/inspection/${inspectionId}/section/${sectionId}/answers/batch`,
    };

    await this.addRequest(request);
  }
}

export const protocolSectionAnswersBatchEditor =
  new ProtocolSectionAnswersBatchEditor(addRequest);
